import { render, staticRenderFns } from "./OfficeSignWrite.vue?vue&type=template&id=784c1aee&scoped=true&"
import script from "./OfficeSignWrite.vue?vue&type=script&lang=js&"
export * from "./OfficeSignWrite.vue?vue&type=script&lang=js&"
import style0 from "./OfficeSignWrite.vue?vue&type=style&index=0&id=784c1aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784c1aee",
  null
  
)

export default component.exports